import styled from 'styled-components';

export const ElapsedSpan = styled.span`
  font-size: 10px;
  font-weight: bold;
  ${({ layout }) => layout === 'horizontal' && 'margin-left: 5px'}
`;
